module.exports = __webpack_public_path__ + "static/media/visa.004f6c2c.svg";